import { Component, Vue } from 'vue-property-decorator';
import { AthleteMetric, AthleteMetricValues } from '@/../types/enums';
import { getMetricIcon } from '../pipes/metric-icon.pipe';
import { getMetricColor } from '../pipes/metric-color.pipe';
import { getMetricUnitLabel } from '../pipes/metric-unit-label.pipe';
import { getMetricUnit } from '../pipes/metric-unit.pipe';
import { youtubeUrl } from '@/helpers/youtube';

@Component
export class AthleteMetricsMixin extends Vue {
	get AllAthleteMetrics(): AthleteMetric[]{
		return AthleteMetricValues;
	}
	get AthleteMetricSelfAssessmentVideoEmbedUrl(): Record<AthleteMetric, string>{
		return {
			[AthleteMetric.Acceleration]: youtubeUrl('Qs29-ITNvjg', true),
			[AthleteMetric.Speed]: youtubeUrl('mMtVvAUewjk', true),
			[AthleteMetric.Agility]: youtubeUrl('ziN758tyiik', true),
			[AthleteMetric.Power]: youtubeUrl('2TU4lmjA464', true),
			[AthleteMetric.Recovery]: youtubeUrl('reX3zra1bpw', true),
		};
	}
	getMetricIcon = getMetricIcon;
	getMetricColor = getMetricColor;
	getMetricUnitLabel = getMetricUnitLabel;
	getMetricUnit = getMetricUnit;
}
